import { DashboardView } from '@/features/dashboard/dashboard-view';

export function DashboardPage() {
  return <DashboardView scope="global" />;
}
